// Each gift's colour, as on the homepage (Dane's): the domain its old name sat in. Edward, Oct 22:
// Apostle became Pioneering, Teacher Teaching, Prophet Prophecy, Evangelist Outreach and Exhorter
// Exhorting, each keeping its colour. It matches the homepage's diamonds; v4 itself ties no gift
// to a domain (any gift can come through any domain), so this is a colour, never a claim.

import type { DomainCode } from "./types";
import { domainColor } from "./domainColors";

export const GIFT_DOMAIN: Record<string, DomainCode> = {
  Pioneering: "STR",
  Teaching: "STR",
  Prophecy: "INF",
  Outreach: "INF",
  Exhorting: "INF",
  Serving: "EXE",
  Giving: "EXE",
  Leading: "EXE",
  Mercy: "REL",
};

/** A gift's colours: its domain's, or the accent for a gift we don't know. */
export const giftColor = (gift: string) => domainColor(GIFT_DOMAIN[gift] ?? "");
